import { create } from 'zustand';

export interface Search {
  address: string;
  lat: number;
  lon: number;
}

export interface MainPageStoreState {
  isOpen: 'boot' | 'places' | 'payment' | 'rent' | 'menu' | 'none';
  startDateIsOpen: boolean;
  parkingID: string | number;
  placeID: string | number;
  search: Search | null;
}

interface MainPageStoreActions {
  openPlaces: (id: string | number) => void;
  openPayment: (id: string | number) => void;
  setIsOpen: (
    isOpen: 'boot' | 'places' | 'payment' | 'rent' | 'menu' | 'none'
  ) => void;
  setStartDateIsOpen: (isOpen: boolean) => void;
  setSearch: (search: Search) => void;
}

interface MainPageStore {
  state: MainPageStoreState;
  actions: MainPageStoreActions;
}

export const useMainPageStore = create<MainPageStore>((set) => ({
  state: {
    isOpen: 'none',
    startDateIsOpen: false,
    parkingID: '',
    placeID: '',
    search: null,
  },
  actions: {
    openPlaces: (id) => {
      set((state) => ({
        state: { ...state.state, isOpen: 'places', parkingID: id },
      }));
    },
    openPayment: (id) => {
      set((state) => ({
        state: { ...state.state, isOpen: 'payment', placeID: id },
      }));
    },
    setIsOpen: (isOpen) => {
      set((state) => ({ state: { ...state.state, isOpen } }));
    },
    setStartDateIsOpen: (isOpen) => {
      set((state) => ({ state: { ...state.state, startDateIsOpen: isOpen } }));
    },
    setSearch: (search) => {
      set((state) => ({ state: { ...state.state, search: search } }));
    },
  },
}));
